import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const noteTypeNotesApi = {
    getNoteTypeNotesByTrialId: (trialId?: number): Observable<Dtos.GetNoteTypeNotesByTrialIdResponse> => {
        //Create the request.
        let request: Dtos.GetNoteTypeNotesByTrialId = new Dtos.GetNoteTypeNotesByTrialId();

        request.trialId = trialId;

        //Send request.
        const response: Promise<Dtos.GetNoteTypeNotesByTrialIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getNoteTypeNotesByTrialInstitutionId: (trialInstitutionId?: number): Observable<Dtos.GetNoteTypeNotesByTrialInstitutionIdResponse> => {
        //Create the request.
        let request: Dtos.GetNoteTypeNotesByTrialInstitutionId = new Dtos.GetNoteTypeNotesByTrialInstitutionId();

        request.trialInstitutionId = trialInstitutionId;

        //Send request.
        const response: Promise<Dtos.GetNoteTypeNotesByTrialInstitutionIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getNoteTypeNotesByInstitutionId: (institutionId?: number): Observable<Dtos.GetNoteTypeNotesByInstitutionIdResponse> => {
        //Create the request.
        let request: Dtos.GetNoteTypeNotesByInstitutionId = new Dtos.GetNoteTypeNotesByInstitutionId();

        request.institutionId = institutionId;

        //Send request.
        const response: Promise<Dtos.GetNoteTypeNotesByInstitutionIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getNoteTypeNotesByPersonnelId: (personnelId?: number): Observable<Dtos.GetNoteTypeNotesByPersonnelIdResponse> => {
        //Create the request.
        let request: Dtos.GetNoteTypeNotesByPersonnelId = new Dtos.GetNoteTypeNotesByPersonnelId();

        request.personnelId = personnelId;

        //Send request.
        const response: Promise<Dtos.GetNoteTypeNotesByPersonnelIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    }
}